import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import FormMixin from '@/amui-fe/mixins/formMixin';
let AmFeRadioField = class AmFeRadioField extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.ruleForm = {
      value: ''
    };
  }
  get label_i18n() {
    return this.label === '单选' ? window.lowcode.i18n.get('apaas_amui_radiofield_label', '单选') : this.label;
  }
};
AmFeRadioField.componentName = 'AmFeRadioField';
__decorate([Prop([String, Number, Boolean])], AmFeRadioField.prototype, "options", void 0);
__decorate([Prop({
  default: 'default'
})], AmFeRadioField.prototype, "shape", void 0);
__decorate([Prop({
  default: 'column'
})], AmFeRadioField.prototype, "itemDirection", void 0);
__decorate([Prop({
  default: false
})], AmFeRadioField.prototype, "border", void 0);
AmFeRadioField = __decorate([Component({
  name: 'AmFeRadioField'
})], AmFeRadioField);
export default AmFeRadioField;